import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import LandPage from '../../../Component/common/LandPage/LandPage'
import Navbar from '../../../Component/common/Navbar/Navbar'
import Topbar from '../../../Component/common/Topbar/Topbar'
import Footer from '../../../Component/common/Footer/Footer';
import {jwtDecode} from 'jwt-decode';
import {GoogleLogin, GoogleOAuthProvider} from '@react-oauth/google'
import { toast, ToastContainer } from 'react-toastify'
import TwoInputs from '../../../Component/common/TwoInputs/TwoInputs'
import axios from 'axios'
import Url from '../../../config/base_url'
import BtnLoader from '../../../Component/common/BtnLoader/BtnLoader'
import { useState } from 'react'
import TokenSlice from '../../../zustand/TokenSlice.js'
import { sendTokenToBackend } from '../../../firebase/sendTokenToBackend';
import UserDataSlice from '../../../zustand/UserDataSlice'
import { getFCMToken } from '../../../firebase/getFCMToken';

function SignUp(){
  const { t } = useTranslation();
  const {createUserDataSlice} = UserDataSlice()

  const handleSuccess = (credentialResponse)=>{
    const decoded = jwtDecode(credentialResponse.credential);
    toast.success(t('successfulLogin'))
  }
  const handleError = ()=>{
    toast.error(t('failedLogin'))
  }

  const [loader , setLoader] = useState(false)
  const nav = useNavigate()
  const {createAccountSlice} = TokenSlice()
  const [data , setData] = useState({
    first_name:"",
    last_name:"",
    phone:"",
    email : "",
    password :"",
    confirmPassword:"",
    gender:""
  })
  const createAccount = async()=>{
    if (
      !data.first_name ||
      !data.last_name ||
      !data.phone ||
      !data.email ||
      !data.password ||
      !data.confirmPassword ||
      !data.gender
    ) {
      toast.warn(t('enterAllFields'));
      return;
    }
    try{
      setLoader(true)
      const res = await axios.post(`${Url}/auth/signup` , data)
        if(res.data.data.accessToken){
          createAccountSlice(res.data.data.accessToken)
          createUserDataSlice(res.data.data.user)
          const fcmToken = await getFCMToken();
          await sendTokenToBackend("userId", fcmToken);
          nav('/' , {state:{success:true , msg:res.data.message}})
        }
    }
    catch (error){
      error.response.data.message.map((item)=>(
        toast.error(item)
      ))
    }
    finally{
      setLoader(false)
    }
  }
  return(
    <GoogleOAuthProvider clientId='917496785589-3bgc091uf923j4da5vattnoocqir337j.apps.googleusercontent.com'>
      <ToastContainer/>
      <Topbar/>
      <Navbar/>
      <LandPage header={t('signUp')} link={t('signUp')} href='/sign-up'/>
      <div className="login-container container">
        <div className="login-content content">
          <div className="leftLogin"></div>
          <div className="rightLogin">
            <div className="header">
              <h2 className='h-after-effect'>{t('signUpHere')}</h2>
              <p>{t('haveAccount')} 
              <Link to="/login">
                {t('loginHereLink')}
              </Link>  
              </p>
            </div>
            <div className='inputs'>
              <TwoInputs 
                typeOne={"text"}
                placeOne={t('firstName')}
                valueOne={data.first_name}
                fnOne={(e)=>setData((prev)=>({...prev,first_name:e.target.value}))}
                typeTwo={"text"}
                placeTwo={t('lastName')}
                valueTwo={data.last_name}
                fnTwo={(e)=>setData((prev)=>({...prev,last_name:e.target.value}))}
              />
              <TwoInputs 
                typeOne={"number"}
                placeOne={t('phone')}
                valueOne={data.phone}
                fnOne={(e)=>setData((prev)=>({...prev,phone:e.target.value}))}
                typeTwo={"email"}
                placeTwo={t('yourEmail')}
                valueTwo={data.email}
                fnTwo={(e)=>setData((prev)=>({...prev,email:e.target.value}))}
              />
              <TwoInputs 
                typeOne={"password"}
                placeOne={t('password')}
                valueOne={data.password}
                fnOne={(e)=>setData((prev)=>({...prev,password:e.target.value}))}
                typeTwo={"password"}
                placeTwo={t('confirmPassword')}
                valueTwo={data.confirmPassword}
                fnTwo={(e)=>setData((prev)=>({...prev,confirmPassword:e.target.value}))}
              />
              <select onChange={(e)=>setData((prev)=>({...prev,gender:e.target.value}))}>
                <option value="" selected disabled>{t('chooseGender')}</option>
                <option value="male">{t('male')}</option>
                <option value="female">{t('female')}</option>
              </select>
            </div>
            <div className="btns">
              {
              loader?
                <BtnLoader/>
              :
            <button onClick={()=>createAccount()}>{t('signUp')}</button>
            }
              {/* <p>OR</p>
              <GoogleLogin
              onSuccess={handleSuccess}
              onError={handleError}
              >
              </GoogleLogin> */}
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </GoogleOAuthProvider>
  )
}
export default SignUp